import React from "react";
import {
  Coin,
  BasketFill,
  PeopleFill,
  Calendar3,
  TaxiFrontFill,
  Bicycle,
  BookmarkHeartFill,
  BoxSeam,
  ChatSquareTextFill,
  Headset,
  Percent,
  GridFill,
  BookmarkCheckFill,
  CashCoin,
  CarFrontFill,
} from "react-bootstrap-icons";

export const getSidebarMenuItems = (info = {}) => {
  const ordersCount = info?.orders;
  const commentsCount = info?.comments;
  const supportsCount = info?.supports;

  const commentsTotal =
    (parseInt(commentsCount?.supplier_comment_food, 10) || 0) +
    (parseInt(commentsCount?.supplier_comment_supermarket, 10) || 0);

  const supportsTotal =
    (parseInt(supportsCount?.supplier_support, 10) || 0) +
    (parseInt(supportsCount?.user_support, 10) || 0);

  return [
    {
      id: "withdraw_requests",
      title: "پرداختی‌ها",
      icon: <Coin />,
      badge: parseInt(info?.withdraw_requests, 10) || null,
      children: [
        {
          id: "1",
          title: "درخواست پرداخت جدید",
          link: "/newpayreq",
          count: parseInt(info?.withdraw_requests, 10) || null,
        },
        { id: "2", title: "بایگانی پرداختی‌ها", link: "/payedreq" },
        { id: "3", title: "پرداخت‌های ناموفق", link: "/failedpay" },
      ],
    },
    {
      id: "orders",
      title: "سفارشات",
      icon: <BasketFill />,
      badge: parseInt(ordersCount?.total, 10) || null,
      children: [
        {
          id: "6",
          title: "همه",
          link: "/allorderfood",
          count: parseInt(ordersCount?.total, 10) || null,
        },
        {
          id: "1",
          title: "فعال",
          link: "/activeorderfood",
          count: parseInt(ordersCount?.active, 10) || null,
        },
        {
          id: "4",
          title: "هوشمند صوتی",
          link: "/intelegentvoiceorder",
        },
        {
          id: "5",
          title: "تحویل داده شده",
          link: "/ordersdeliveredfood",
          count: parseInt(ordersCount?.delivered, 10) || null,
        },
        {
          id: "2",
          title: "پرداخت نشده",
          link: "/notpaidorder",
          count: parseInt(ordersCount?.not_paied, 10) || null,
        },
        {
          id: "3",
          title: "کنسل شده",
          link: "/canceledorder",
          count: parseInt(ordersCount?.canceled, 10) || null,
        },
      ],
    },
    {
      id: "users",
      title: "کاربر",
      icon: <PeopleFill />,
      groups: [
        {
          id: "user_list",
          title: "لیست کاربر",
          children: [
            { id: "1", title: "مشتری", link: "/customer" },
            { id: "2", title: "تأمین‌کننده", link: "/supplier" },
            { id: "4", title: "ادمین", link: "/admin" },
            { id: "5", title: "راننده و پیک", link: "/driver" },
          ],
        },
        {
          id: "add_user",
          title: "افزودن کاربر",
          children: [
            { id: "1", title: "تأمین‌کننده", link: "/addsupplier" },
            { id: "3", title: "ادمین", link: "/addadmin" },
            { id: "4", title: "راننده و پیک", link: "/adddriver" },
          ],
        },
      ],
    },
    {
      id: "factors",
      title: "فاکتور",
      icon: <Calendar3 />,
      children: [
        { id: "1", title: "ایجاد فاکتور", link: "/addfactor" },
        { id: "2", title: "لیست فاکتور", link: "/factorlist" },
      ],
    },
    {
      id: "taxi",
      title: "تاکسی",
      icon: <TaxiFrontFill />,
      badge: parseInt(info?.taxi?.active, 10) || null,
      children: [
        { id: "2", title: "همه درخواست‌های تاکسی", link: "/alltaxireq" },
      ],
    },
    {
      id: "delivery",
      title: "پیک",
      icon: <Bicycle />,
      badge: parseInt(info?.delivery?.active, 10) || null,
      children: [
        { id: "1", title: "همه درخواست‌های پیک", link: "/alldeliveryreq" },
        { id: "2", title: "ضریب هزینه پیک", link: "/deliverycost" },
      ],
    },
    {
      id: "barest_help",
      title: "کمک برست",
      icon: <BookmarkHeartFill />,
      children: [
        { id: "1", title: "دریافتی‌های کمک برست", link: "/baresthelplist" },
      ],
    },
    {
      id: "products",
      title: "کالا",
      icon: <BoxSeam />,
      children: [
        { id: "1", title: "لیست محصولات فروشگاهی", link: "/superyProducts" },
        { id: "2", title: "ثبت کالا رستورانی", link: "/restaurantproduct" },
        { id: "3", title: "ثبت کالا فروشگاهی", link: "/supermarketproduct" },
        {
          id: "4",
          title: "اختصاص کالا رستورانی",
          link: "/assignproducttorestaurant",
        },
        {
          id: "5",
          title: "اختصاص کالا فروشگاهی",
          link: "/assignproducttosupermarket",
        },
        { id: "6", title: "لیست غذاهای رستوران", link: "/foodslist" },
        {
          id: "7",
          title: "ویرایش محصولات تأمین‌کننده",
          link: "/editproductbasesupplier",
        },
      ],
    },
    {
      id: "comments",
      title: "نظرات",
      icon: <ChatSquareTextFill />,
      badge: commentsTotal || null,
      children: [
        {
          id: "1",
          title: "رستوران",
          link: "/restaurantcomment",
          count: parseInt(commentsCount?.supplier_comment_food, 10) || null,
        },
        {
          id: "2",
          title: "فروشگاه",
          link: "/supermarketcomment",
          count:
            parseInt(commentsCount?.supplier_comment_supermarket, 10) || null,
        },
      ],
    },
    {
      id: "supports",
      title: "پیام‌های پشتیبانی",
      icon: <Headset />,
      badge: supportsTotal || null,
      children: [
        {
          id: "1",
          title: "تأمین‌کننده",
          link: "/suppliersupport",
          count: parseInt(supportsCount?.supplier_support, 10) || null,
        },
        {
          id: "2",
          title: "کاربر",
          link: "/usersupport",
          count: parseInt(supportsCount?.user_support, 10) || null,
        },
        {
          id: "3",
          title: "پیک",
          link: "/deliverysupport",
          count: parseInt(supportsCount?.delivery_support, 10) || null,
        },
      ],
    },
    {
      id: "discounts",
      title: "مدیریت تخفیف",
      icon: <Percent />,
      children: [
        { id: "1", title: "اختصاص کد تخفیف", link: "/creatediscountcode" },
        {
          id: "2",
          title: "کد تخفیف شخصی",
          link: "/createprivatediscountcode",
        },
        {
          id: "5",
          title: "لیست کد تخفیف شخصی",
          link: "/privatediscountcodelist",
        },
        {
          id: "3",
          title: "ایجاد کد تخفیف عمومی",
          link: "/createpublicdiscountcode",
        },
        {
          id: "4",
          title: "لیست کد تخفیف عمومی",
          link: "/publicdiscountcodelist",
        },
      ],
    },
    {
      id: "categories",
      title: "دسته‌بندی",
      icon: <GridFill />,
      children: [
        {
          id: "1",
          title: "افزودن دسته‌بندی فروشگاه",
          link: "/addnewcategory",
        },
        {
          id: "2",
          title: "ویرایش دسته‌بندی محصولات",
          link: "/editproductscategory",
        },
        {
          id: "3",
          title: "لیست دسته‌بندی سطح اول فروشگاه",
          link: "/firstcategorylist",
        },
        {
          id: "4",
          title: "لیست دسته‌بندی سطح دوم فروشگاه",
          link: "/secondcategorylist",
        },
        {
          id: "5",
          title: "افزودن دسته‌بندی رستوران",
          link: "/addresturantcategory",
        },
        {
          id: "6",
          title: "لیست دسته‌بندی رستوران",
          link: "/resturantcategorylist",
        },
      ],
    },
    {
      id: "brands",
      title: "برند",
      icon: <BookmarkCheckFill />,
      children: [
        { id: "1", title: "افزودن برند", link: "/addbrand" },
        { id: "2", title: "لیست برندها", link: "/brandlist" },
      ],
    },
    {
      id: "accounting",
      title: "حسابداری",
      icon: <CashCoin />,
      children: [
        { id: "1", title: "واریزی‌ها", link: "/income" },
        { id: "2", title: "برداشتی‌ها", link: "/outcome" },
      ],
    },
    {
      id: "vehicles",
      title: "وسیله نقلیه",
      icon: <CarFrontFill />,
      children: [
        { id: "1", title: "افزودن وسیله نقلیه", link: "/addcar" },
        { id: "2", title: "لیست وسیله نقلیه", link: "/carlist" },
        { id: "3", title: "افزودن رنگ", link: "/addcolor" },
        { id: "4", title: "لیست رنگ", link: "/colorlist" },
      ],
    },
  ];
};
